import React, { useState, useEffect } from "react";
import { Actividad } from "../../../api";
import { useAuth } from "../../../hooks";
import { ModalCustom } from "../../Shared/ModalCustom/ModalCustom";

const actividadAPI = new Actividad();

export function HistorialActividadesModal({ isVisible, onClose, documentoId }) {
  const { accessToken } = useAuth();
  const [actividades, setActividades] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isVisible && documentoId) {
      fetchActividades();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, documentoId]);

  const fetchActividades = async () => {
    try {
      setLoading(true);
      const data = await actividadAPI.getActividadesByDocumento(accessToken, documentoId);
      setActividades(data);
    } catch (error) {
      console.error("Error fetching actividades", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalCustom isVisible={isVisible} onClose={onClose} size="m">
      <div className="p-6">
        <div className="border-b border-gray-100 pb-4 mb-4 flex items-center justify-between">
          <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <span>📋</span> Historial de Procesos
          </h3>
          <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full font-medium">
            {actividades.length} registros
          </span>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-2 border-[#151C84]/20 border-t-[#151C84] rounded-full animate-spin"></div>
          </div>
        ) : actividades.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <span className="text-4xl mb-3 block">📭</span>
            <p>No hay procesos registrados aún.</p>
          </div>
        ) : (
          <div className="space-y-4 max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
            {actividades.map((act) => (
              <div key={act.id} className="relative pl-6 pb-4 border-l-2 border-gray-100 last:border-0 last:pb-0">
                <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full border-2 border-white bg-[#151C84]"></div>
                <div className="bg-gray-50 rounded-xl p-4 ml-2">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-gray-900 text-sm">
                      {act.accion.replace(/_/g, " ")}
                    </span>
                    <span className="text-xs text-gray-500 font-medium">
                      {new Date(act.createdAt).toLocaleString()}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 whitespace-pre-wrap">{act.detalles}</p>
                  <p className="text-xs text-gray-400 mt-2">
                    Por: {act.usuario?.name || "Sistema"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </ModalCustom>
  );
}
